var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvAppleStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8108 13.9C17.3796 14.8578 17.1718 15.2859 16.6171 16.1312C15.8405 17.3125 14.7452 18.7875 13.3921 18.7969C12.1874 18.8078 11.8765 18.0109 10.2405 18.025C8.60614 18.0328 8.26552 18.8125 7.05927 18.8C5.70458 18.7875 4.66864 17.4594 3.89208 16.2797C1.72021 12.9719 1.49052 9.09374 2.83271 7.03124C3.78271 5.56874 5.28427 4.70937 6.69521 4.70937C8.13271 4.70937 9.03583 5.49843 10.2233 5.49843C11.3765 5.49843 12.078 4.70781 13.7405 4.70781C14.9968 4.70781 16.3249 5.39218 17.2749 6.57343C14.1686 8.27656 14.6733 12.7125 17.8108 13.9ZM12.478 3.38749C13.0827 2.61093 13.5421 1.51562 13.3749 0.399994C12.389 0.467181 11.2358 1.09687 10.5624 1.91249C9.95146 2.65624 9.44521 3.75937 9.64208 4.82656C10.7186 4.86093 11.8327 4.21874 12.478 3.38749Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvAppleStore);
export default __webpack_public_path__ + "static/media/ctv_apple_store.91c49207b26cb20b61c638fed03860b5.svg";
export { ForwardRef as ReactComponent };